module.exports = __webpack_public_path__ + "seo-main.04820fb.jpg";